module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/favicon-12842238e1b7105198db5ab226d77d611d5.png";